import { PointerEventHandler, useRef } from 'react';
import { ReactHooks } from '@team/react-hooks';
import { ActiveStateProps, StateSettings } from '../types';
import { detectStateClassName } from '../lib';

const ACTIVE_DELAY_MS = 70;

export function useActive({
  hasActive = true,
  shouldForceActivated = false,
  activeClassName,
  activeEffectDelay = 450,
}: ActiveStateProps): StateSettings {
  const actors = useRef(new Set<number>());
  const [state, setState] = ReactHooks.useStateWithDelay(false);

  const className = detectStateClassName(
    hasActive,
    shouldForceActivated,
    state,
    activeClassName
  );

  const handlePointerDown: PointerEventHandler = () => {
    setState(true, ACTIVE_DELAY_MS);
  };

  const handlePointerCancel: PointerEventHandler = ({ pointerId }) => {
    if (actors.current.has(pointerId)) {
      actors.current.delete(pointerId);
      return;
    }

    setState(false);
  };

  const handlePointerUp: PointerEventHandler = ({ pointerId }) => {
    actors.current.add(pointerId);
    setState(true);
    setState(false, activeEffectDelay);
  };

  return {
    className,
    handlers: {
      onPointerLeave: hasActive ? handlePointerCancel : undefined,
      onPointerDown: hasActive ? handlePointerDown : undefined,
      onPointerCancel: hasActive ? handlePointerCancel : undefined,
      onPointerUp: hasActive ? handlePointerUp : undefined,
    },
  };
}
